import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="relative h-[90vh] bg-cover bg-center flex items-center"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1490818387583-1baba5e638af?auto=format&fit=crop&q=80")'
        }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              Welcome to Healthy Kitchen
            </h1>
            <p className="text-xl md:text-2xl mb-8">
              Fresh, organic, and delicious meals for a healthier you
            </p>
            <Link
              to="/menu"
              className="bg-brand-500 hover:bg-brand-600 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
            >
              View Our Menu
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center"
            >
              <h3 className="text-xl font-semibold mb-4 text-brand-400">Fresh Ingredients</h3>
              <p className="text-gray-100">
                We use only the freshest, locally-sourced organic ingredients
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-center"
            >
              <h3 className="text-xl font-semibold mb-4 text-brand-400">Healthy Options</h3>
              <p className="text-gray-100">
                Nutritious and delicious meals for every dietary preference
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="text-center"
            >
              <h3 className="text-xl font-semibold mb-4 text-brand-400">Expert Chefs</h3>
              <p className="text-gray-100">
                Crafted with care by our experienced culinary team
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;